import axios from '../request/http.js'

class Administrator {
  /* 获取所有的模块管理员/角色列表 */
  static getModuleAdministrator() {
    let url = `/zzd/api/back/biz/role/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取某一管理员（角色）的角色用户 */
  static getModuleAdministratorRoleType(subAdminId, userName, pageNo) {
    let url = `/zzd/api/back/sub/admin/user/list?subAdminId=${subAdminId}&userName=${userName}&pageNo=${pageNo}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 删除角色用户 */
  static postModuleAdministratorDelRoleType(data) {
    let url = `/zzd/api/back/sub/admin/user/del`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取全部权限信息 */
  static getModuleAdministratorAuthority(moduleType) {
    let url = `/zzd/api/back/sub/admin/authority/list/base?moduleType=${moduleType}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 保存权限 */
  static getSaveModuleAdministratorAuthority(data) {
    let url = `/zzd/api/back/sub/admin/authority/save`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取某模块管理员具有的权限 */
  static getModuleAdministratorAuthorityDetails(id) {
    let url = `/zzd/api/back/sub/admin/authority/list?id=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 可见的模块管理员和角色 */
  static getModuleAdministratorRoleList(id) {
    let url = `/zzd/api/back/sub/admin/authority/list/sub/admin/role?id=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取二级管理员权限 */
  static getTwolevelAuthority() {
    let url = `/zzd/api/back/sub/admin/authority/list/mine`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 添加角色用户 */
  static postSaveRoleType(data) {
    let url = `/zzd/api/back/sub/admin/user/add`
    return axios.post(url,data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default Administrator